// App.js
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/header';
import HeroSection from './components/Herosection';
import GeospatialApplications from './components/GeospatialApplications'; // Import the new subpage
import GeospatialDataGovernance from './components/GeospatialDataGovernance'; // Import the new subpage
import Framework from './components/framework'; // Import the new subpage
import Policies from './components/policies'; // Import the new subpage
import Footer from './components/Footer';
import Standards from './components/Standards';
//import OfficialSaudiMap from './components/OfficialSaudiMap';//OfficialSaudiMap
//import EasternRegion from './components/EasternRegion';//EasternRegion
import SaudiTideTables from './components/SaudiTideTables';//SaudiTideTables
import HistoricalImages from './components/HistoricalImages';//HistoricalImages
import GeospatialUnit from './components/GeospatialUnit';//GeospatialUnit
import DigitalLibrary from './components/DigitalLibrary';//DigitalLibrary
import SANGE from './components/SANGE';//SANGE
import SOCIOECONOMIC_IMPACT from './components/Socio_Economic_Impact';//SOCIOECONOMIC_IMPACT
import Effective_Geospatial_Collaboration from './components/EffectiveGeospatialCollaboration';//SLA DOC
import KSA_Natioanl_Geospatial_Governance from './components/KSANatioanlGeospatialGovernance';//SLA DOC
import GKI_Readiness_Index from './components/GKIReadinessIndex';//GKIReadinessIndex
import SANGE_Establishment from './components/SANGE_Establishment';//SLA DOC
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse';//TermsOfUse
import AboutUs from './components/AboutUs';//AboutUs
import NationalGeocatalog from './components/national-geocatalog';//AboutUs
import GeocatalogAgreement from './components/Geocatalog_agreement';//AboutUs
import GeographicalNames from './components/GeographicalNames';//GeographicalNames
//import OpenData from './components/OpenData';//OpenData
import GeospatialOpenData from './components/GeospatialOpenData';//GeospatialOpenData
import DigitalTwin from './components/DigitalTwin';//DigitalTwin
//import Maritime from './components/Maritime';//Maritime
import NationalGeospatialModel from './components/NationalGeospatialModel';//NationalGeospatialModel
import NationalGeospatialMetadataProfile from './components/NationalGeospatialMetadataProfile';//NationalGeospatialMetadataProfile
import NationalFeatureConceptDictionary from './components/NationalFeatureConceptDictionary';//NationalFeatureConceptDictionary
import Specifications from './components/Specifications';//Specifications
import Geodesy from './components/geodesy';//Geodesy
import SANSRS from './components/sansrs';//sansrs.js
import KSAVRF14 from './components/ksavrf14';//KSAVRF14
import KSAGRF17 from './components/ksagrf17';//KSAGRF17
import KSAVRF14_FAQ from './components/KSAVRF14_FAQ';//KSAVRF14_FAQ


import KSAGRF17_FAQ from './components/KSAGRF17_FAQ';//KSAGRF17_FAQ

import GeodeticTools from './components/GeodeticTools';//GeodeticTools
import KSAGEOID17 from './components/ksagoid17';//KSAGEOID17
import KSAGEOID17_FAQ from './components/KSAGEOID17_FAQ';//KSAGEOID17_FAQ
import KSACORS from './components/ksacors';//KSACORS
import KSACORS_FAQ from './components/KSACORS_FAQ';//KSACORS_FAQ
import NGN from './components/NGN';//NGN
import NVN from './components/NVN';//NVN
import FAQ from './components/Faq';
import SANSRS_Implementation_Guidelines from './components/SANSRS_Implementation_Guidelines';
import SANSRS_Technical_Summary from './components/SANSRS_Technical_Summary';
import ComingSoon from './components/coming_soon';//ComingSoon

import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import './App.css'; // Custom styles
import FeedbackButton from './components/FeedbackButton';
import ScrollToTop from './components/ScrollToTop'; // Import ScrollToTop
import HomepageUserGuide from './components/HomepageUserGuide'; // Import ScrollToTop


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <Router  basename="/Geoportal">
      <ScrollToTop /> {/* Add ScrollToTop component */}
        <div className="App">
          <Header />
          <HomepageUserGuide/>
          <Routes>
          
            {/* Define routes for different pages */}
            <Route path="/" element={<HeroSection />} />
            <Route path="/geospatial-applications" element={<GeospatialApplications />} />
            <Route path="/Geospatial-Governance" element={<GeospatialDataGovernance />} />
            <Route path="/Framework" element={<Framework />} />
            <Route path="/Policies" element={<Policies />} />
            <Route path="/Standards" element={<Standards />} />
            <Route path="/Specifications" element={<Specifications />} />
            <Route path="/Digital-library" element={<DigitalLibrary />} />
            <Route path="/Geospatia-Unit" element={<GeospatialUnit />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/TermsOfUse" element={<TermsOfUse />} />
            <Route path="/AboutUs" element={<AboutUs />} />
            <Route path="/SANGE" element={<SANGE />} />
            <Route path="/SOCIO-ECONOMIC-IMPACT" element={<SOCIOECONOMIC_IMPACT />} />
            <Route path="/Effective-Geospatial-Collaboration" element={<Effective_Geospatial_Collaboration />} />
            <Route path="/KSANatioanlGeospatialGovernance" element={<KSA_Natioanl_Geospatial_Governance />} />
            <Route path="/GKIReadinessIndex" element={<GKI_Readiness_Index />} />
            <Route path="/SANGE_Establishment" element={<SANGE_Establishment />} />

            <Route path="/national-geocatalog" element={<NationalGeocatalog />} />

            <Route path="/national-geocatalog/Agreement" element={<GeocatalogAgreement />} />
            <Route path="/GeographicalNames" element={<GeographicalNames />} />
            
            {/* <Route path="/GeospatialOpenData/OfficialSaudiMap" element={<OfficialSaudiMap />} /> */}
            <Route path="/GeospatialOpenData" element={<GeospatialOpenData />} />
            {/* <Route path="/GeospatialOpenData/EasternRegion" element={<EasternRegion />} /> */}
            <Route path="/GeospatialOpenData/SaudiTideTables" element={<SaudiTideTables />} />
            <Route path="/GeospatialOpenData/HistoricalImages" element={<HistoricalImages />} />
            


            
            <Route path="/DigitalTwin" element={<DigitalTwin />} />
             {/*<Route path="/Maritime" element={<Maritime />} />*/}
            <Route path="/NationalGeospatialModel" element={<NationalGeospatialModel />} />
            <Route path="/NationalGeospatialMetadataProfile" element={<NationalGeospatialMetadataProfile />} />
            <Route path="/NationalFeatureConceptDictionary" element={<NationalFeatureConceptDictionary />} />
            <Route path="/FAQ" element={<FAQ />} />
            <Route path="/Geodesy" element={<Geodesy />} />
            <Route path="/Geodesy/Sansrs" element={<SANSRS />} />
            <Route path="/Geodesy/KSACors" element={<KSACORS />} />
            <Route path="/Geodesy/KSACors/FAQ" element={<KSACORS_FAQ />} />
            
            <Route path="/Geodesy/NGN" element={<NGN />} />
            <Route path="/Geodesy/NVN" element={<NVN />} />
            
            <Route path="/Geodesy/Sansrs/Implementation_Guidelines" element={<SANSRS_Implementation_Guidelines />} />
            <Route path="/Geodesy/Sansrs/Technical_Summary" element={<SANSRS_Technical_Summary />} />
            <Route path="/Geodesy/Sansrs/KSAVRF14" element={<KSAVRF14 />} />
            <Route path="/Geodesy/Sansrs/KSAVRF14/FAQ" element={<KSAVRF14_FAQ />} />
            <Route path="/Geodesy/Sansrs/KSAGRF17" element={<KSAGRF17 />} />
            <Route path="/Geodesy/Sansrs/KSAGRF17/FAQ" element={<KSAGRF17_FAQ />} />

            <Route path="/Geodesy/Sansrs/KSAGEOID17" element={<KSAGEOID17 />} />
            <Route path="/Geodesy/Sansrs/KSAGEOID17/FAQ" element={<KSAGEOID17_FAQ />} />
            
            <Route path="/Geodesy/GeodeticTools" element={<GeodeticTools />} />
            <Route path="/ComingSoon" element={<ComingSoon />} />
            {/* Add other routes as needed */}
          </Routes>
          <FeedbackButton/>
          
          <Footer />
        </div>
      </Router>
    </I18nextProvider>
  );
}

export default App;
